<template>
  <BravadoTheme class="layout layout--clear">
    <div :class="rootClass">
      <ClientOnly>
        <TopNotification />
      </ClientOnly>
      <WarRoomMobileAppBannerTop />
      <nuxt />
      <GlobalComponents />
    </div>
  </BravadoTheme>
</template>

<script>
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

export default {
  name: 'ClearLayout',
  mixins: [defaultLayoutMixin],
  computed: {
    rootClass() {
      return ['clear-layout'];
    },
  },
};
</script>
